import { Component, Input } from '@angular/core';
import { EdlTemplateTypeDTO, EdlTemplateTypesService } from '@edl-development/edl-common';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'edl-template-types-management',
    templateUrl: './edl-template-types-management.component.html',
    styleUrls: ['./edl-template-types-management.component.scss']
})
export class EdlTemplateTypesManagementComponent {
    @Input() edlTemplateTypes: EdlTemplateTypeDTO[] = [];

    public busy: boolean = false;
    
    constructor(
        private edlTemplateTypesService: EdlTemplateTypesService,
        private toastrService: ToastrService
    ) {}

    onCreate = () => {
        if (this.busy) return;

        this.busy = true;

        firstValueFrom(this.edlTemplateTypesService.create({
            Id: '',
            Title: `Template Type ${this.edlTemplateTypes.length + 1}`,
            CanModify: true,
        })).then((newTemplateType: EdlTemplateTypeDTO) => {
            this.edlTemplateTypes.push(newTemplateType);
            this.toastrService.success('Template Type created successfully', 'Success');
        }).finally(() => {
            this.busy = false;
        });
    }

    onSave = (templateType: EdlTemplateTypeDTO) => {
        if (this.busy) return;

        this.busy = true;

        firstValueFrom(this.edlTemplateTypesService.update(templateType))
            .then((updatedTemplateType: EdlTemplateTypeDTO) => {
                const index = this.edlTemplateTypes.findIndex((t) => t.Id === updatedTemplateType.Id);
                if (index !== -1) this.edlTemplateTypes[index] = updatedTemplateType;
                this.toastrService.success('Template Type updated successfully', 'Success');
            }).finally(() => {
                this.busy = false;
            });
    }

    onDelete = (id: string) => {
        if (this.busy) return;

        this.busy = true;

        firstValueFrom(this.edlTemplateTypesService.delete(id))
            .then(() => {
                const index = this.edlTemplateTypes.findIndex((t) => t.Id === id);
                if (index !== -1) this.edlTemplateTypes.splice(index, 1);
                this.toastrService.success('Template Type deleted successfully', 'Success');
            }).finally(() => {
                this.busy = false;
            });
    }

    trackByFn = (index: number, entryData: EdlTemplateTypeDTO) => {
        return entryData.Id;
    }
}
